// extracted by mini-css-extract-plugin
export default {"card":"roles_card__A13l3","cardTitle":"roles_cardTitle__-g5IO"};